var _g, _rect, _path, _path2, _circle, _circle2, _circle3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "52.5 74 174 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 134,
    r: 60,
    fill: "#F71111"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 134,
    r: 59.5,
    stroke: "#CED3D6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.9,
    y: 143.4,
    width: 7.2,
    height: 7.2,
    rx: 1.6,
    stroke: "#38C5F2",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.355 90.7481L203.426 85.1697L204.721 94.0827L196.355 90.7481Z",
    stroke: "#EF24DB",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.152 186.543L188.223 180.965L189.518 189.878L181.152 186.543Z",
    stroke: "#73B024",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 134.5,
    r: 4.1,
    stroke: "#DAC507",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 204.5,
    r: 4.1,
    stroke: "#37B7FF",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 90.5,
    r: 4.1,
    stroke: "#FF9F2E",
    strokeWidth: 0.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1861_13495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.348 125.743C151.846 125.743 152.298 125.96 152.656 126.328C152.989 126.72 153.157 127.208 153.108 127.723C153.108 127.893 151.776 144.743 151.015 151.835C150.538 156.188 147.732 158.83 143.523 158.903C140.287 158.975 137.124 159 134.009 159C130.703 159 127.469 158.975 124.33 158.903C120.262 158.805 117.454 156.115 117.002 151.835C116.219 144.718 114.911 127.893 114.887 127.723C114.862 127.208 115.028 126.72 115.363 126.328C115.694 125.96 116.17 125.743 116.671 125.743H151.348ZM139.162 109C141.372 109 143.346 110.542 143.918 112.742L144.326 114.567C144.657 116.055 145.945 117.107 147.429 117.107H154.718C155.69 117.107 156.5 117.915 156.5 118.942V119.892C156.5 120.895 155.69 121.727 154.718 121.727H113.285C112.31 121.727 111.5 120.895 111.5 119.892V118.942C111.5 117.915 112.31 117.107 113.285 117.107H120.574C122.055 117.107 123.343 116.055 123.676 114.57L124.058 112.865C124.651 110.542 126.604 109 128.838 109H139.162Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1861_13495",
    x: 0,
    y: 0,
    width: 280,
    height: 280,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.580392 0 0 0 0 0.85098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1861_13495"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1861_13495",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1861_13495",
    x: 92,
    y: 92,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1861_13495"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1861_13495",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCard);
export default __webpack_public_path__ + "static/media/delete-card.5e4ba1961425a80a07ad9e980328153f.svg";
export { ForwardRef as ReactComponent };